<template>
  <div class="tab-main">
    <div class="tab-header">
      <div :class="['tab-box', { 'selected': i == pTabIndex, 'first': i == 0, 'last': i == tabs.length - 1, 'disabled': t['disabled'] }]"
        :style="{ borderTopColor: i == pTabIndex ? (t['headerColor'] ? t['headerColor'] : '') : '' }"
        v-for="(t, i) in tabs" :key="i" @click="tabClicked(t, i)">
        {{ t['title'] }}
        <slot class="tab-details" :name="`${t['title']}_details`"></slot>
      </div>
    </div>
    <div class="tab-content">
      <div v-for="(t, i) in tabs" :key="i" :style="{ height: i == pTabIndex ? '100%' : 'unset' }">
        <slot :name="t['title']" v-if="i == pTabIndex"></slot>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      pTabIndex: 0
    }
  },
  props: {
    tabs: { type: Array, default: function() { return [] } },

    tabIndex: { type: Number, default: 0 },
    preventTabSwitch: { type: Boolean, default: false }, // to prevent tab switching when a user clicks on a tab, used when something needs to be done before the tab switch occurs
    // listen to @tabClicked and manually change the tab index once the something is done and the tab can be switched

    // Public events
    // @tabClicked - fired when a is clicked on by the user, but not when changed programatically, returns the object and index of the clicked tab
  },
  methods: {
    tabClicked: function(tab, index) {
      this.$emit("tabClicked", tab, index);

      if (!this.preventTabSwitch) { // if not preventing tab switch
        this.pTabIndex = index; // automatically switch the tab over once the user clicks on a tab
        this.$emit('update:tabIndex', this.pTabIndex);
      }
    }
  },
  mounted() {
    this.pTabIndex = this.tabIndex;
  },
  watch: {
    tabIndex: function(newVal, oldVal) {
      this.pTabIndex = newVal;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.tab-main {
  > .tab-header {
    display: flex;
    min-height: 40px;

    > .tab-box {
      border: 1px solid rgba(0,0,0,0.3);
      flex-grow: 1;
      width: 100%;
      text-align: center;
      padding: 3px 5px;
      background-color: white;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 15px;
      flex-direction: column;
    }

    > .disabled {
      background-color: rgba(128,128,128,0.3);
      pointer-events: none;
    }

    > .selected {
      border-width: 5px 1px 0 1px;
      // border-color: rgba(0,0,0,0.3) rgba(0,0,0,0.3) rgba(0,0,0,0.3) rgba(0,0,0,0.3);
      border-color: #26b900 rgba(0,0,0,0.3) rgba(0,0,0,0.3) rgba(0,0,0,0.3);
      // 00bfff
      border-style: solid;
      transform: scale(1.1);
      transform-origin: center bottom;
    }

    > .first {
      transform-origin: 0 100%;
    }

    > .last {
      transform-origin: 100% 100%;
    }

    > .disabled {
      pointer-events: none;
      background-color: rgba(128,128,128,0.3);
    }
  }

  > .tab-content {
    border-color: rgba(0,0,0,0.3);
    border-style: solid;
    border-width: 0 1px 1px 1px;
    padding: 5px;
    // height: fit-content;
    height: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
}
</style>